import { render, staticRenderFns } from "./QrcodeCapture.vue?vue&type=template&id=a040cc1e&lang=html&"
import script from "./QrcodeCapture.vue?vue&type=script&lang=js&"
export * from "./QrcodeCapture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports